export default __webpack_public_path__ + "static/home-banner0829-886741865ae2cc9b5a993baf08f7ec43.jpg";